import React, {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from 'react';

interface LayoutContextType {
  showFooter: boolean;
  setShowFooter: (visible: boolean) => void;
  showHeader: boolean;
  setShowHeader: (visible: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

interface LayoutProviderProps {
  children: ReactNode;
  defaultVisible?: boolean;
}

export const LayoutProvider: React.FC<LayoutProviderProps> = ({
  children,
  defaultVisible = true,
}) => {
  const [showFooter, setShowFooter] = useState(defaultVisible);
  const [showHeader, setShowHeader] = useState(true);

  return (
    <LayoutContext.Provider
      value={{
        showFooter,
        setShowFooter,
        showHeader,
        setShowHeader,
      }}
    >
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};
